<template>
  <tr v-if="testInput.input_type === 'checkbox'">
    <td colspan="10">
      <b-form-group class="text-left">
        <b-form-checkbox-group v-model="value" stacked style="margin: 1rem;">
          <b-form-checkbox
            v-for="(option, index) in test.options"
            :key="`option-checkbox-${index}`"
            style="margin: 1rem;"
            :value="option.value"
            @blur="checkTestAlert(option.name, 'watch')"
          >
            <b-row>
              <b-col cols="auto">{{ option.name }}</b-col>
              <b-col v-if="option.has_text_field" cols="auto">
                <b-form-input
                  style="height: 1.5rem;"
                  :type="testInput.options[index].input_type"
                  @input="changeTextfieldOptionCheckbox($event, index)"
                />
              </b-col>
            </b-row>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </td>
  </tr>
  <tr v-else>
    <td>
      <template>
        <b-form-checkbox v-model="testInput.is_checked" />
      </template>
    </td>
    <td>
      <span
        class="test-clicker"
        @click="
          testHistoryShowHandler(testInput.id, testInput.type === 'subTest')
        "
        >{{ testInput.name }}</span
      >
      <b-modal
        id="testHistoryModal"
        ref="testHistoryModal"
        centered
        size="lg"
        hide-header
        ok-only
      >
        <test-history-modal-component :data="testHistoryData" />
      </b-modal>
    </td>
    <td>
      <template
        v-if="
          testInput.input_type === 'text' || testInput.input_type === 'number'
        "
      >
        <b-form-input
          :id="`${indexInput}`"
          ref="resultInput"
          v-model="value"
          :tabindex="1000"
          :type="testInput.input_type"
          :style="{ 'background-color': checkRanges() }"
          @keyup.enter.native="nextInput($event)"
          @blur="checkTestAlert(testInput.name, 'watch')"
        />
      </template>
      <template v-else-if="testInput.input_type === 'dropdown'">
        <b-form-select
          ref="resultInput"
          v-model="value"
          :tabindex="1000"
          :options="testInput.options"
          value-field="value"
          text-field="name"
          @keyup.enter.native="nextInput($event)"
          @change="change"
        >
          <template v-slot:first>
            <option :value="null" />
          </template>
        </b-form-select>
      </template>
    </td>
    <td>
      <template v-if="testInput.input_type === 'dropdown' && chooseOptionIndex">
        <b-form-input
          v-if="testInput.options[chooseOptionIndex].has_text_field"
          v-model="testInput.options[chooseOptionIndex].option_value"
          :type="testInput.options[chooseOptionIndex].input_type"
          @blur="checkTestAlert(testInput.name, 'watch')"
        />
        <b-form-input v-else :value="lastResult" disabled />
      </template>
      <template v-else>
        <b-form-input :value="lastResult" disabled />
      </template>
    </td>
    <td>
      {{
        dayLastResult
          ? typeof dayLastResult == "string"
            ? dayLastResult
            : moment(dayLastResult.created_at).format("DD/MM/YYYY")
          : null
      }}
    </td>
    <td style="text-align: left;">
      <span style="white-space: pre;"> {{ testInput.ref_ranges }}</span>

      <!-- <b-button
        :class="{'ref-range-icon-add': true, 'has': remarkRefRange ? remarkRefRange.length > 0 : false}"
        @click="()=> {$refs.remarkRefRangeModal.show();}"
      >
        <fa-icon icon="plus" />
      </b-button>
      <b-modal
        id="remarkRefRangeModal"
        ref="remarkRefRangeModal"
        centered
        size="lg"
        hide-header
        ok-only
      >
        <remark-ref-range-modal-component v-model="remarkRefRange" />
      </b-modal>-->
    </td>
    <td>{{ testInput.unit }}</td>
    <!-- <td>{{ testInput.qc_regulation }}</td> -->
    <td>{{ testInput.machine }}</td>
    <!-- <td>{{ testInput.remark }}</td> -->
    <td>
      <b-form-checkbox
        v-if="fileAttachInput"
        v-model="useOutlabInput"
        :value="true"
        :unchecked-value="false"
        tabindex="-1"
      />
    </td>
    <td>
      <file-upload-component
        v-if="fileAttachInput"
        :file-upload.sync="fileAttachInput"
        :item-index="testInput.id"
        in-table
      />
    </td>
  </tr>
</template>

<script>
import FileUploadComponent from "./FileUploadComponent";
// import RemarkRefRangeModalComponent from "../../components/Result/RemarkRefRangeModalComponent";
import TestHistoryModalComponent from "../../components/Result/TestHistoryModalComponent";
import { mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";

export default {
  name: "TestRow",
  components: {
    FileUploadComponent,
    // RemarkRefRangeModalComponent,
    TestHistoryModalComponent,
  },
  props: {
    indexInput: {
      type: Number,
    },
    subComponent: {
      type: Boolean,
    },
    test: {
      default: null,
    },
    useOutlab: {
      default: false,
    },
    fileAttach: {
      default: null,
    },
    lastResult: {
      default: null,
    },
    dayLastResult: {
      default: null,
    },
    checkTestAlert: {
      type: Function,
    },
  },
  data() {
    return {
      chooseOptionIndex: null,
      testHistoryData: [],
      moment,
    };
  },
  computed: {
    ...mapGetters({
      animal: "Animal/getData",
    }),
    minRange() {
      if (this.testInput.ref_ranges) {
        if (this.testInput.ref_ranges.includes(">")) {
          return +this.testInput.ref_ranges.replace(">", "");
        } else if (this.testInput.ref_ranges.includes("<")) {
          return null;
        } else if (this.testInput.ref_ranges.includes("-")) {
          return +this.testInput.ref_ranges.split("-")[0];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    maxRange() {
      if (this.testInput.ref_ranges) {
        if (this.testInput.ref_ranges.includes(">")) {
          return +this.testInput.ref_ranges.replace(">", "");
        } else if (this.testInput.ref_ranges.includes("<")) {
          return null;
        } else if (this.testInput.ref_ranges.includes("-")) {
          return +this.testInput.ref_ranges.split("-")[1];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    remarkRefRange: {
      get() {
        return this.testInput.remark_ref_range;
      },
      set(value) {
        this.testInput.remark_ref_range = value;
      },
    },
    value: {
      get() {
        return this.subComponent ? this.test.option_value : this.test.value;
      },
      set(value) {
        // console.log(value)
        // this.subComponent ? this.$emit('update:test', { ...this.test, option_value: value }) : this.$emit('update:test', { ...this.test, value })
        this.subComponent
          ? (this.testInput.option_value = value)
          : (this.testInput.value = value);

        // console.log('real test', this.test)
        // console.log('value',  { ...this.test, value })
      },
    },
    testInput: {
      get() {
        return this.test;
      },
      set(value) {
        this.$emit("update:test", value);
        // console.log(this.test)
      },
    },
    fileAttachInput: {
      get() {
        return this.fileAttach;
      },
      set(value) {
        this.$emit("update:fileAttach", value);
      },
    },
    useOutlabInput: {
      get() {
        return this.useOutlab;
      },
      set(value) {
        this.$emit("update:useOutlab", value);
      },
    },
  },
  mounted() {
    this.setOptionValue(this.testInput.value);
    // console.log(this.indexInput, this.test.name)
  },
  watch: {
    remarkRefRange(value) {},
  },
  methods: {
    ...mapActions({
      getLastResultOfAnimal: "Result/getLastResultOfAnimal",
    }),
    checkRanges() {
      if (!this.minRange && !this.maxRange) {
        return "white";
      }

      if (!this.value || this.value === "") {
        return "white";
      } else if (+this.value < this.minRange || +this.value > this.maxRange) {
        return "#FFE866";
      } else {
        return "#86f47f";
      }
    },
    setOptionValue(value) {
      if (
        this.testInput.input_type === "dropdown" ||
        this.testInput.input_type === "radio" ||
        this.testInput.input_type === "checkbox"
      ) {
        const chooseOption = this.testInput.options.findIndex(
          (val) => val.value === value
        );
        if (chooseOption > -1) {
          this.chooseOptionIndex = chooseOption;
        }
      }
    },
    change(value) {
      this.setOptionValue(value);
      this.checkTestAlert(this.testInput.name, "watch");
    },
    nextInput(val) {
      // console.log('inputAmount', this.inputAmount)
      // console.log('parentIndex', this.parentIndex)
      // console.log('indexInput', this.indexInput)
      // this.$refs.resultInput.focus()
      this.$emit("tab");
    },
    changeTextfieldOptionCheckbox(event, index) {
      const oldValue = this.testInput.options[index].value;
      this.testInput.options[index].value = event;
      this.value.push(event);
      this.value = this.value.filter((val) => val !== oldValue);
    },
    async testHistoryShowHandler(testId, isSubTest = false) {
      this.$store.state.isLoading = true;
      const animalId = this.animal.id;
      this.testHistoryData = [];
      let res;
      try {
        res = await this.getLastResultOfAnimal({ animalId, testId, isSubTest });
      } catch (err) {
        this.$swal.fire("Error", err.message, "error");
        this.$store.state.isLoading = false;

        return;
      }
      this.testHistoryData = res;
      this.$refs.testHistoryModal.show();
      this.$store.state.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.ref-range-icon-add {
  background-color: #eeeeee;
  // padding: 2px 5px;
  border-radius: 25px;
  cursor: pointer;
  color: black;

  &.has {
    background-color: green;
    color: white;
  }
}

.test-clicker {
  cursor: pointer;
  text-decoration: underline;
}

/* remove arrow in number input  */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
